import React, { memo } from "react";
import ListHeader from '../../../../../shared/components/ListHeader';
import ListContainer from '../../../../../shared/components/ListContainer';
import styles from "./listDevicesToUpload.module.scss";
import { useTranslation } from "react-i18next";

const ListDevicesToUpload = ({ itemsAvailableToInsert, itemsUnavailableToInsert }) => {

    const { t } = useTranslation(["devices", "home"]);

    return (
        <div className={styles.wrapper} >

            {
                itemsUnavailableToInsert && itemsUnavailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.error}`}>
                        {`${itemsUnavailableToInsert.length} ${t("home:devices")} ${t("home:with_conflict")}`}
                    </ListHeader>

                    <ListHeader className={styles.subHeader}>
                        <div> IMEI </div>
                        <div> {t('devices:provider')} </div>
                        <div> {t('home:status')} </div>
                    </ListHeader>

                    <ListContainer>
                        {itemsUnavailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{item.imei}</div>
                                <div>{item.provider}</div>
                                <div>{item.status_code}</div>
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

            {
                itemsAvailableToInsert && itemsAvailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.success}`}>
                        {`${itemsAvailableToInsert.length} ${t("home:devices")} ${t("home:redy_to_upload")}`}
                    </ListHeader>

                    <ListHeader className={styles.subHeader}>
                        <div> IMEI </div>
                        <div> {t('devices:provider')} </div>
                        <div> {t('devices:status')} </div>
                    </ListHeader>

                    <ListContainer>
                        {itemsAvailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{item.imei}</div>
                                <div>{item.provider}</div>
                                <div>{item.status_code}</div>
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

        </div>
    )
}

export default memo(ListDevicesToUpload);